<template>
  <div class="w12 confirm-page">
    <mypage-header> </mypage-header>

    <div class="pt16 pr16 pb16 pl16">
      <auth-email :step="authLevel" :email="email"></auth-email>
      <auth-identity class="mt12" :auth-data="authData"></auth-identity>
      <!-- <auth-bank class="mt16" :auth-data="authData"></auth-bank> -->
      <auth-otp class="mt16" :auth-data.sync="authData"></auth-otp>
    </div>
  </div>
</template>

<script>
import Api from "@/common/Api";
import { mapState, mapGetters } from "vuex";
import GlobalEvent from "@/common/Event";

import MypageHeader from "./component/mypage/header.vue";

import authEmail from "./component/confirm/authEmail";
import authBank from "./component/confirm/authBank";

import authIdentity from "./component/confirm/authIdentity/index.vue";
import authOtp from "./component/confirm/authOTP";
import { authIDModal } from "@/common/authIdModal";

export default {
  components: {
    MypageHeader,
    authEmail,
    authIdentity,
    authBank,
    authOtp,
  },
  data() {
    return {
      email: "",
      phone: "",
      foreign: false,
    };
  },
  mounted() {
    this.$store.dispatch("updateUserInfo");
    Promise.all([
      Api.User.getUserPrivateInfo("email"),
      Api.User.getUserPrivateInfo("phone"),
    ]).then(([email, phone]) => {
      this.email = email.body.data;
      this.phone = phone.body.data;
    });
    authIDModal(this.userInfo);
  },
  computed: {
    ...mapState(["Server"]),
    ...mapGetters([
      "authLevel",
      "authStep",
      "userInfo",
      "accounts",
      "authResidence",
      "useOTP",
      "hasAccount",
    ]),
    isForeign() {
      return this.userInfo.foreignYn == "Y";
    },
    authData() {
      return {
        isPhone: this.phone ? true : false,
        isBank: this.hasAccount,
        isOtp: this.useOTP,
        isForeign: this.foreign,
        KYCType: this.authResidence,
      };
    },
  },
  methods: {},
};
</script>
